export default __webpack_public_path__ + "static/media/398.d9f4560b.png";